import { ApiService } from "./api.service";
export default class ReviewCheckService extends ApiService {
  namespace = "previewCheck";
  DOMAIN = -68;
  name = "Preview Check";
  template = "defaultTemplate";
  Width = 1150;
  favicon = "SaveTick";
  constructor() {
    super("ap-check");
  }
}
